import React, { useState, useEffect, useRef } from "react";
import "./Settings.css"
import "./Company.css";
import "./Style.css";
import Billing from "./Billing";
import Employee from "./Employee";
import Tablereservations from "./Tablereservations";
import Tickets from "./Tickets";
import Timings from "./Timings";
import Orders from './Orders';
import { Link } from "react-router-dom";
import { FaChevronDown, FaChevronUp, FaCommentAlt, FaPaperPlane } from "react-icons/fa";

const Settings = () => {
  const plan = localStorage.getItem("planType") || "standard";
  const [isOpen, setIsOpen] = useState(false);
  const [ticketType, setTicketType] = useState("");
  const [message, setMessage] = useState("");
  const [attachment, setAttachment] = useState(""); // base64 image

  const [activeTab, setActiveTab] = useState('Timings');
  const [isHovered, setIsHovered] = useState(false);
  const scrollContainerRef = useRef(null);
  const isMobile = window.innerWidth <= 768;

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        const result = reader.result;
        // Ensure we only get base64 data (after the comma)
        const base64Data = result.split(',')[1];
        setAttachment(base64Data);
      };
      reader.readAsDataURL(file);
    }
  };

  const handleSendTicket = async () => {
    const vendorId = localStorage.getItem("vendorId");
    const token = localStorage.getItem("authToken");

    if (!vendorId || !token) {
      alert("Vendor ID or Token not found in localStorage.");
      return;
    }

    if (!ticketType || !message) {
      alert("Please fill all the fields");
      return;
    }

    const payload = {
      vendorId: Number(vendorId),
      ticketType,
      message,
      attachmentUrl: attachment || "", // base64 encoded image
    };

    try {
      const response = await fetch(
        "https://backend.maamaas.com/food/vendor-tickets/create",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify(payload),
        }
      );

      const result = await response.json();

      if (response.ok) {
        alert("Ticket submitted successfully!");
        setTicketType("");
        setMessage("");
        setAttachment("");
        setIsOpen(false);
      } else {
        console.error("API Error:", result);
        alert(result.message || "Failed to submit ticket.");
      }
    } catch (error) {
      console.error("Fetch Error:", error);
      alert("Something went wrong while submitting the ticket.");
    }
  };


  useEffect(() => {
    const scrollContainer = scrollContainerRef.current;
    if (!scrollContainer) return;

    let interval;

    const startScrolling = () => {
      interval = setInterval(() => {
        if (!isHovered) {
          scrollContainer.scrollTop += 1; // Scroll down smoothly

          // Infinite loop logic
          if (scrollContainer.scrollTop >= scrollContainer.scrollHeight / 2) {
            scrollContainer.scrollTop = 0; // Reset to top for seamless loop
          }
        }
      }, 20); // Adjust speed by changing interval
    };

    startScrolling();
    const allDays = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];

    return () => clearInterval(interval);
  }, [isHovered]);
  const getOrderColor = (orderType) => {
    switch (orderType) {
      case "Dine-In":
        return "#1E90FF"; // Blue
      case "Take Away":
        return "#FF6347"; // Tomato
      case "Delivery":
        return "#20B2AA"; // LimeGreen
      default:
        return "#ccc"; // Grey
    }
  };
  const fileInputRef = useRef(null);
  // {=======================overview===============================}
  const allTabs = {

    Timings: <Timings />,
    Employee: <Employee />,
    "Billing SetUp": <Billing />,
    Table: <Tablereservations />,
    "View Tickets": <Tickets />,
  };

  // Filter tabs by plan
  const getTabsForPlan = (plan) => {
    switch (plan.toLowerCase()) {
      case "basic":
        return ["Timings", "Billing SetUp", "View Tickets"];
      case "standard":
        return ["Timings", "Employee", "Billing SetUp", "View Tickets"];
      case "premium":
        return ["Timings", "Employee", "Billing SetUp", "Table", "View Tickets"];
      default:
        return ["Employee"];
    }
  };

  const visibleTabKeys = getTabsForPlan(plan);
  return (<>


    <style>{`
        .main-container {
          padding: 20px;
          display: flex;
          flex-direction: column;
         
        }

         .tabs-wrapperyy {
          display: flex;
          flex-direction: column;
          align-items: center;
          gap: 10px;
          margin-left:0px;
          margin-top:67px;
}
// .left-column {
//             width: 100%;
//             padding-right: 140px;
//             max-height: 700px;
           
//           }


/* Mobile view ke liye (max-width 768px ya 600px aapke design ke hisaab se) */
@media screen and (max-width: 768px) {
  .tabs-wrapper {
    margin-left: 0;
    
  }
}


        .tab-buttons {
          display: flex;
          flex-wrap: wrap;
          justify-content: center;
          gap: 10px;
          margin-top:81px;
         
        }

        .tab-button {
          border: none;
          border-radius: 10px;
          width: 150px;
          height: 40px;
          background-color: #d9d9d9;
          color: #000;
          font-weight: bold;
          cursor: pointer;
          transition: background-color 0.3s ease;
        }

        .tab-button.active {
          background-color: #b15cd6;
        }

        .tab-content {
          margin-top: 0px;
          width: 100%;
          max-width:840px;
          
        }

        .sidebar {
          margin-top: 30px;
          max-height: 600px;
          overflow-y: auto;
        }

        .card {
          width: 100%;
          max-width: 300px;
          height: 120px;
          background: #ccc;
          border-radius: 8px;
          box-shadow: 0px 2px 4px rgba(0,0,0,0.1);
          margin: 10px auto;
          position: relative;
          padding: 10px;
        }

        .card h5, .card p {
          color: white;
          margin: -18 !imortanant;
        }

        

        
        @media (min-width: 768px) {
          .main-container {
            flex-direction: row;
            justify-content: space-between;
          }

          

          .left-column {
            width: 100%;
            padding-right: 95px;
            max-height: 700px;
           
          }
             

          .right-column {
            width: 30%;
            position: sticky;
            top: -30px;
            max-height: 700px;
            overflow-y: auto;
          }

          .card {
            margin-left: 0;
          }
            .tabs-wrapper{
            margin-left:none

            }

        }

        /* Hide native scrollbars */
        .sidebar::-webkit-scrollbar,
        .left-column::-webkit-scrollbar {
          width: 0px;
          background: transparent;
        }
      `}</style>

    <div className="container-fluid">
      <div className="row">
        <div className="col-lg-2"></div>
        <div className="Col-lg-7">
          <p
            className="breadcrumb maamaas-home-bredcum"
            style={{
              position: "fixed",
              top: isMobile ? "50px" : "80px",
              left: isMobile ? "5px" : "275px",
              width: "100%",
              backgroundColor: "#fff",
              zIndex: 1000,
              padding: "10px 0",
              fontSize: isMobile ? "14px" : "18px",
              fontWeight: isMobile ? "normal" : "bold",
              textAlign: "center",
              margin: 0,
            }}
          >
            {/* <Link
              to="/Newmainlandingpage"
              style={{
                color: "purple",
                fontWeight: "bold",
                textDecoration: "none",
              }}
            >
              Home
            </Link> */}
            <span className="separator"> &gt; </span>
            <Link
              to="/company"
              style={{
                color: "purple",
                fontWeight: "bold",
                textDecoration: "none",
              }}
            >
              DigitalMenuBillings
            </Link>
            <span className="separator"> &gt; </span>
            <Link
              to="/settings"
              style={{
                color: "purple",
                fontWeight: "bold",
                textDecoration: "none",
              }}
            >
              Settings
            </Link>


          </p>




          {/* Left Section */}
          <div className="left-column" style={{}}>
            <div className="tabs-wrapperyy ">

              <div className="tab-buttons" style={{}}>
                {visibleTabKeys.map((label) => (
                  <button
                    key={label}
                    className={`tab-button ${activeTab === label ? "active" : ""}`}
                    onClick={() => setActiveTab(label)}
                  >
                    {label}
                  </button>
                ))}
              </div>
              <div className="tab-content" style={{
                overflow: 'auto', height: '500px', scrollbarWidth: "none",
                msOverflowStyle: "none",
              }}> {allTabs[activeTab]}</div>
            </div>
          </div>

          <div
            style={{
              position: "fixed",
              bottom: "0px",
              right: "32px",
              width: "300px",
              backgroundColor: "#fff",
              boxShadow: "0 4px 10px rgba(0, 0, 0, 0.2)",
              borderRadius: "10px",
              overflow: "hidden",
              transition: "height 0.3s ease-in-out",
              height: isOpen ? "400px" : "50px",
              zIndex: 9999,
            }}
          >
            {/* Header with Toggle Button */}
            <div
              style={{
                backgroundColor: "#b15cd6",
                color: "#fff",
                padding: "10px",
                fontWeight: "bold",
                textAlign: "center",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                cursor: "pointer",
              }}
              onClick={() => setIsOpen(!isOpen)}
            >
              <FaCommentAlt style={{ marginLeft: "10px" }} />
              <span style={{ flexGrow: 1, textAlign: "center" }}>Support</span>
              {isOpen ? <FaChevronDown style={{ marginRight: "10px" }} /> : <FaChevronUp style={{ marginRight: "10px" }} />}
            </div>

            {/* Chat Content */}
            {isOpen && (
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  flex: 1,
                  overflowY: "auto",
                  padding: "10px",
                  height: "352px",
                  scrollbarWidth: "none"
                }}
              >
                <h4 style={{ textAlign: "center", marginBottom: "10px" }}>Raise a Ticket</h4>

                {/* Ticket Type Dropdown */}
                <label style={{ fontWeight: "bold" }}>Ticket Type</label>
                <select
                  value={ticketType}
                  onChange={(e) => setTicketType(e.target.value)}
                  style={{
                    marginBottom: "10px",
                    padding: "8px",
                    borderRadius: "5px",
                    border: "1px solid #ccc",
                    outline: "none",
                  }}
                >
                  <option value="">Select Ticket Type</option>
                  <option value="PAYOUT_ISSUE">Payout Issue</option>
                  <option value="SUBSCRIPTION_ISSUE">Subscription Issue</option>
                  <option value="ORDER_COMPLAINT">Order Complaint</option>
                  <option value="TECHNICAL_SUPPORT">Technical Support</option>
                  <option value="OTHER">Other</option>
                </select>

                {/* Message Input */}
                <label style={{ fontWeight: "bold" }}>Message</label>
                <input
                  value={message}
                  onChange={(e) => setMessage(e.target.value)}
                  placeholder="Type your Issue here..."
                  rows={3}
                  style={{
                    marginBottom: "10px",
                    padding: "8px",
                    borderRadius: "5px",
                    border: "1px solid #ccc",
                    height: "50px"

                  }}
                />

                {/* Attachment Upload */}
                <label style={{ fontWeight: "bold" }}>Attachment</label>
                <input
                  type="file"
                  accept="image/*"
                  onChange={handleImageChange}
                  style={{ marginBottom: "10px" }}
                />

                {/* Submit Button */}
                <button
                  onClick={handleSendTicket}
                  style={{
                    padding: "10px",
                    backgroundColor: "#b15cd6",
                    color: "#fff",
                    border: "none",
                    borderRadius: "5px",
                    fontWeight: "bold",
                    cursor: "pointer",
                  }}
                >
                  Send Ticket
                </button>
              </div>
            )}

          </div>
        </div>
        {activeTab !== "" && (
          <div>
            <Orders />
          </div>
        )}
      </div>
    </div>
  </>
  );
};



export default Settings;
